// Barrel file — maintains backward compatibility for all imports from "@/data/articles"
// All existing imports continue to work unchanged.

export type { Article, Category, ArticleSection, CountryContent, CountryItems } from "./types";
export { categories } from "./categories";

// Import legacy articles + per-category new articles
import { legacyArticles, applyFreshDates, normalizeAudibleLinks } from "../articles-legacy";
import type { Article, Category } from "./types";
import { categories } from "./categories";

// Import per-category new article arrays
import { homeRepairsArticles } from "./home-repairs";
import { moneyFinanceArticles } from "./money-finance";
import { foodCookingArticles } from "./food-cooking";
import { cleaningRoutinesArticles } from "./cleaning-routines";
import { lifeAdminArticles } from "./life-admin";
import { societySystemsArticles } from "./society-systems";
import { socialRelationshipsArticles } from "./social-relationships";
import { workCareerArticles } from "./work-career";
import { housingRentingArticles } from "./housing-renting";
import { transportDrivingArticles } from "./transport-driving";
import { insuranceProtectionArticles } from "./insurance-protection";
import { digitalLifeArticles } from "./digital-life";

// Combine all articles
export const articles: Article[] = [
  ...legacyArticles,
  ...homeRepairsArticles,
  ...moneyFinanceArticles,
  ...foodCookingArticles,
  ...cleaningRoutinesArticles,
  ...lifeAdminArticles,
  ...societySystemsArticles,
  ...socialRelationshipsArticles,
  ...workCareerArticles,
  ...housingRentingArticles,
  ...transportDrivingArticles,
  ...insuranceProtectionArticles,
  ...digitalLifeArticles,
];

// Apply post-processing
applyFreshDates(articles);
normalizeAudibleLinks(articles);

// Helper functions
export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((article) => article.categorySlug === categorySlug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((article) => article.slug === slug);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((category) => category.slug === slug);
}

export function searchArticles(query: string): Article[] {
  const lowercaseQuery = query.toLowerCase();
  return articles.filter(
    (article) =>
      article.title.toLowerCase().includes(lowercaseQuery) ||
      article.description.toLowerCase().includes(lowercaseQuery) ||
      article.content.toLowerCase().includes(lowercaseQuery)
  );
}
